"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectsBenchmarkClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class ProjectsBenchmarkClient extends authenticated_client_1.AuthenticatedClient {
    getHistograms(projectId, params = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParams = this.getQueryString(params);
            const response = yield this.httpGet(`/v1/projects/${projectId}/projects-benchmark/histograms?${queryParams}`);
            return response.payload;
        });
    }
    getIndustry(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/projects-benchmark/industry`);
            return response.payload;
        });
    }
}
exports.ProjectsBenchmarkClient = ProjectsBenchmarkClient;
//# sourceMappingURL=projects-benchmark.client.js.map